<template>
<div>
  <v-row class="pt-4 pb-3 pl-4 pr-4 b-b mb-0" dense>
    <v-col>
      <v-select label="ELY Center" v-model="filters.elyCenters" :items="elyCenters" outlined multiple clearable
        hide-details dense :menu-props="{ offsetY: true }"></v-select>
    </v-col>
    <v-col>
      <v-select label="Area" v-model="filters.areas" :items="areas" outlined multiple clearable hide-details dense
        :menu-props="{ offsetY: true }"></v-select>
    </v-col>
    <v-col>
      <v-text-field label="ISCO Class" v-model="filters.iscoClass" outlined clearable hide-details dense></v-text-field>
    </v-col>
    <v-col>
      <v-dialog ref="startDateDialog" v-model="startDateModal" :return-value.sync="filters.startDate" persistent
        width="290px">
        <template v-slot:activator="{ on, attrs }">
          <v-text-field v-model="filters.startDate" label="Start date after" prepend-inner-icon="mdi-calendar" readonly
            v-bind="attrs" v-on="on" outlined dense clearable hide-details></v-text-field>
        </template>
        <v-date-picker v-model="filters.startDate" scrollable>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="startDateModal = false">
            Cancel
          </v-btn>
          <v-btn text color="primary" @click="$refs.startDateDialog.save(filters.startDate)">
            OK
          </v-btn>
        </v-date-picker>
      </v-dialog>
    </v-col>
    <v-col>
      <v-dialog ref="endDatedialog" v-model="endDateModal" :return-value.sync="filters.endDate" persistent width="290px">
        <template v-slot:activator="{ on, attrs }">
          <v-text-field v-model="filters.endDate" label="End date before" prepend-inner-icon="mdi-calendar" readonly
            v-bind="attrs" v-on="on" outlined dense clearable hide-details></v-text-field>
        </template>
        <v-date-picker v-model="filters.endDate" scrollable>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="endDateModal = false">
            Cancel
          </v-btn>
          <v-btn text color="primary" @click="$refs.endDatedialog.save(filters.endDate)">
            OK
          </v-btn>
        </v-date-picker>
      </v-dialog>
    </v-col>
    <v-col>
      <v-text-field label="Search" outlined dense hide-details v-model="filters.searchString"></v-text-field>
    </v-col>
    <v-col>
      <v-btn outlined block color="primary" elevation="0" @click="importDialog = true">
        Import policies
      </v-btn>
      <PolicyImportModal :dialog="importDialog" @cancel="importDialog = false" @saved="getPolicies()" />
    </v-col>
    <v-col>
      <v-btn block color="primary" elevation="0" @click="createPolicy()">
        <v-icon size="small">mdi-plus</v-icon>
        Add policy
      </v-btn>
    </v-col>
  </v-row>
  <v-row dense no-gutters>
    <v-col :cols="showEditor ? 9 : 12">
      Selected items: {{ selectedRows.length }}
      <div class="list-view">
        <v-data-table :loading="loading" :headers="headers" :items.sync="items" :search="filters.searchString" :page.sync="page"
          :items-per-page="itemsPerPage" @page-count="pageCount = $event" class="elevation-1" show-select
          hide-default-footer @click:row="selectRow" v-model="selectedRows">
          <template v-slot:[`item.areas`]="{ item }">
            {{item.areas.map(area=>area.name).join(', ')}}
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <!-- <v-icon small class="mr-2" @click="editRow(item)" disabled>
              mdi-pencil
            </v-icon> -->
            <v-icon small color="error" @click="deleteRow(item)">
              mdi-delete
            </v-icon>
          </template>
          <template v-slot:[`item.startDate`]="{ item }">
            <span>{{ item.startDate.split('T')[0] }}</span>
          </template>
          <template v-slot:[`item.endDate`]="{ item }">
            <span>{{ item.endDate.split('T')[0] }}</span>
          </template>
        </v-data-table>
        <v-row class="pagination align-center">
          <v-col class="ml-2">
            <strong>Page {{ page }}</strong> of {{ pageCount }}
          </v-col>
          <v-col>
            <v-pagination v-model="page" :length="pageCount" total-visible="8"></v-pagination>
          </v-col>
        </v-row>
      </div>
    </v-col>
    <v-col class="b-l" v-if="showEditor">
      <div class="editor">
        <PolicyEditor :item="selectedPolicy" :action="editorAction" @saved="getPolicies()" @close="showEditor = false" />
      </div>
    </v-col>
  </v-row>
</div>
</template>
<script>
import PolicyImportModal from '@/components/PolicyImportModal.vue';
import PolicyEditor from '@/components/PolicyEditor.vue';

export default {
  name: 'PolicyList',
  components: {
    PolicyImportModal,
    PolicyEditor,
  },
  data() {
    return {
      headers: [
        { text: 'ELY Center', value: 'elyCenter' },
        { text: 'Area(s)', value: 'areas' },
        { text: 'ISCO Class', value: 'iscoClass' },
        { text: 'Start date', value: 'startDate' },
        { text: 'End date', value: 'endDate' },
        { text: 'Label', value: 'label' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      elyCenters: [
        'Etelä-Savon ELY-keskus',
        'Hämeen ELY-keskus',
        'Kaakkois-Suomen ELY-keskus',
        'Kainuun ja Pohjois-Pohjanmaan ELY-keskus',
        'Keski-Suomen ELY-keskus',
        'Lapin ELY-keskus',
        'Pirkanmaan ELY-keskus',
        'Pohjanmaan ja Etelä-Pohjanmaan ELY-keskus',
        'Pohjois-Karjalan ELY-keskus',
        'Pohjois-Savon ELY-keskus',
        'Satakunnan ELY-keskus',
        'Uudenmaan ELY-keskus',
        'Varsinais-Suomen ELY-keskus',
      ],
      startDateModal: false,
      endDateModal: false,
      filters: {
        elyCenters: [],
        areas: [],
        iscoClass: '',
        startDate: '',
        endDate: '',
        searchString: '',
      },
      itemsPerPage: 8,
      page: 1,
      pageCount: 0,
      selectedPolicy: {},
      importDialog: false,
      showEditor: false,
      editorAction: 'create',
      loading: false,
      selectedRows: [],
    };
  },
  async mounted() {
    await this.getPolicies();
  },
  methods: {
    selectRow(row) {
      this.selectedPolicy = row;
      this.editorAction = 'update';
      this.showEditor = true;
      this.$emit('selectRow', row);
    },
    deleteRow(row) {
      this.$store.dispatch('dispatchDeletePolicy', { id: row.id }).then(() => {
        this.getPolicies();
      });
    },
    async getPolicies() {
      this.loading = true;
      this.importDialog = false;
      await this.$store.dispatch('dispatchGetPolicies');
      this.loading = false;
    },
    createPolicy() {
      this.selectedPolicy = {
        elyCenter: '',
        areas: [],
        iscoClass: '',
        startDate: '',
        endDate: '',
        label: '',
        labelTranslations: {
          fi: '',
          sv: '',
          en: '',
        },
      };
      this.editorAction = 'create';
      this.showEditor = true;
      this.$emit('selectRow', this.selectedPolicy);
    },
  },
  computed: {
    items() {
      const items = this.$store.state.policies.map((item) => {
        return {
          ...item,
          startDate: item.startDate,
          endDate: item.endDate,
        };
      });
      return items.filter((item) => {
        const itemFilterStates = [
          this.filters.elyCenters.length > 0 ? this.filters.elyCenters.includes(item.elyCenter) : true,
          this.filters.areas.length > 0 ? item.areas.some(area => this.filters.areas.includes(area.id)) : true,
          this.filters.iscoClass.length > 0 ? item.iscoClass.startsWith(this.filters.iscoClass) : true,
          this.filters.startDate ? (
            new Date(item.startDate).getTime() > new Date(this.filters.startDate).getTime()
          ) : true,
          this.filters.endDate ? (
            new Date(item.endDate).getTime() < new Date(this.filters.endDate).getTime()
          ) : true,
        ];
        return itemFilterStates.every(f => f);
      });
    },
    areas() {
      return this.$store.state.mapData.map((area) => {
        return { text: area.name, value: area.id };
      });
    },
  },
};
</script>
<style scoped>
.list-view {
  height: 70vh;
  overflow-y: scroll;
  overflow-x: hidden;
}

.editor {
  height: 70vh;
  overflow-y: scroll;
  overflow-x: hidden;
}
</style>
<style>
.pagination .v-pagination {
  justify-content: end;
}
</style>
